import { render, staticRenderFns } from "./tripDetail.vue?vue&type=template&id=3fa08608&scoped=true"
import script from "./tripDetail.vue?vue&type=script&lang=js"
export * from "./tripDetail.vue?vue&type=script&lang=js"
import style0 from "./tripDetail.vue?vue&type=style&index=0&id=3fa08608&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa08608",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fa08608')) {
      api.createRecord('3fa08608', component.options)
    } else {
      api.reload('3fa08608', component.options)
    }
    module.hot.accept("./tripDetail.vue?vue&type=template&id=3fa08608&scoped=true", function () {
      api.rerender('3fa08608', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/leftMoudle/tripDetail.vue"
export default component.exports